export default {
  title: 'Academy',
  description:
    'Create courses for your users, and link them using academy builder.',
  description_alt:
    'Build an enterprise-grade Customer Academy designed to increase product adoption, retention, and customer advocacy.',
  tab: {
    course: {
      title: 'Course Builder',
      desc: 'Create, access, manage, and share all your courses from here.',
      cta: 'Create a course',
    },
    builder: {
      title: 'Academy Builder',
      desc: 'Build and manage your Academy from here.',
      cta: 'Go to Academy Builder',
    },
    event: {
      title: 'Training Events',
      desc: 'Create and manage instructor-led training sessions for your learners.',
      cta: 'Create Event',
    },
  },
  button: {
    enable: 'Enable Academy',
    disable: 'Disable Academy',
  },
  quiz: {
    untitled: 'Untitled Quiz',
    imported_successfully: 'Quiz Imported Successfully',
    title: 'Edit Questions',
    description:
      'Add multiple choice / checkbox type questions to your assessment.',
    question: {
      title: 'Question Title',
      type: 'Question Type',
      add_option: 'Add option',
      add: 'Add Question',
      answer_hint: 'Set as Answer',
      saved: 'Question saved',
      deleted: 'Question deleted',
      upload: 'Upload Image',
      generate: "Generate Questions",
      generating: "Generating..."
    },
    answer_key: 'Answer key',
    point: 'point',
    points: 'points',
    choose: 'Choose correct answers:',
    quiz_settings_updated: 'Quiz settings updated',
    generate: {
      title: 'Generate Questions',
      desc: 'Trainn will automatically generate questions from the lessons you select below',
      questions_count: "Max Questions Count",
      choices_count: "Max Choices Count",
      no_lessons: "No lessons available for selection",
    }
  },
  analytics: {
    allow_crawling: 'Allow google to crawl your academy',
    allow_crawling_label: 'For Search Engine Optimisation',
    allow_ga_label: 'For Google Analytics',
    allow_ga: 'Enable Google Analytics Tracking',
    enter_tracking_code: 'Enter code',
    tracking_code_label: 'Google Analytics tracking code',
    tracking_code_desc: 'Copy and paste your Google Analytics tracking code',
    cross_origin_tracking_label: 'Enable cross origin tracking',
    origin_ids_label: 'Origin Ids',
    origin_ids_placeholder: 'Enter domain names',
    origin_ids_desc: 'Use comma to separate domain names',
  },
  lesson: {
    untitled: 'Untitled Lesson',
    delete: 'Delete Lesson',
  },
  courses: {
    course_name: 'Course Name',
    all_courses: 'All Courses',
    create: 'Create Course',
    link_course: 'Link Course',
    course_builder: 'Course Builder',
    untitled: 'Untitled Course',
    untitled_placeholder: 'Enter a course name',
    desc_placeholder:
      'Add a brief description',
    sort: {
      based_on: 'Sort your courses based on recently',
      created: 'created',
      updated: 'updated',
      published: 'published',
    },
    publish: 'Publish Course',
    preview: 'Preview Course',
    reviews: 'Reviews',
    published_successfully: 'Course published succesfully',
    publish_modal: {
      title: 'Confirm publish',
      desc: 'Select who to notify:',
      notify_current:
        'Notify learners currently taking this course (recommended)',
      notify_completed: 'Notify learners who completed this course',
      publish_btn: 'Publish Now',
    },
    sub_heading:
      '<b>Create a Course</b> — will be added to your “All Courses” library',
    analytics: 'Analytics',
    upload: {
      title: 'Course Cover',
      type: 'Upload Image',
      desc: 'Minimum size 1440x780 pixels',
      from_library: 'Choose Video',
      from_library_desc: 'from Library',
      pdf: 'Upload PDF',
      loading: 'Uploading...',
      uploading: 'Uploading...',
      processing: 'Processing...',
      video: 'Video Updated Successfully',
      scorm: 'Upload SCORM'
    },
    general: {
      details: 'Course Description',
      description: 'Edit this course’s description:',
      desc_placeholder: 'Describe your course in detail, including what learners will achieve, topics covered, and why it matters.',
      comment_title: 'Enable Comments',
      comment_desc:
        'Allows learners to leave comments that are visible to all course participants.',
      internal_name: 'Internal Name',
      internal_name_desc:
        'Add an internal name that only you can see. Helpful for identifying when you have similar courses in different languages.',
      settings: 'Course Settings',
      chapters_title: 'Require Sequential Progress',
      chapters_desc:
        'This setting will force learners to complete lessons in order.',
      seeking_title: 'Prevent Skipping',
      seeking_desc: 'This setting prevents learners from skipping ahead in video lessons. Learners should watch the entire video to complete a lesson.',
      autoplay_toggle_title: 'Enable Autoplay',
      autoplay_toggle_desc:
        'Automatically play the next video lesson when the current one finishes.',
      playback_speed_control_title: 'Allow Speed Control',
      playback_speed_control_desc:
        'Learners can adjust video playback speed to their preferred learning pace.',
      assesment_title:
        'Learners can get certified through an assessment at the end of this course',
      assesment_desc:
        'You will be required to set up a detailed assessment round under the “Exam & Certification” menu',
      certificate_title: 'Enable Certification',
      certificate_desc:
        'Learners can earn a certificate after completing the course or assessment.',
      include_pricing_title: 'Set as Paid Course',
      include_pricing_desc: 'Learners need to pay to get access to this course content.',
      course_feedback_title: 'Collect Course Feedback',
      course_feedback_desc:
        'Gather learner feedback to improve your course and boost its visibility.',
      stripe_price_id_title: 'Stripe Product',
      stripe_price_id_desc: 'Select Stripe Product for the course',
      strikethrough_price_title: 'Original Price',
      strikethrough_price_desc: 'Original price of the course',
      discount_price_title: 'Discounted Price',
      discount_price_desc:
        'Final price that is to be payable after discount to access the content',
      currency_title: 'Currency',
      currency_desc:
        'Currency in which the course has to be charged to access the content',
      price: "Price",
      author: {
        label: 'Add Course Authors',
        desc: 'Add author information to build credibility and connect with learners.',
        add: 'Add Author Information',
        modal_title: 'Add Author Details',
        modal_desc:
          'You can choose from the list or add new author information',
        no_author_found: 'No authors found',
      },
      enable_playback_speed: "Playback speed cannot be controlled by learners if ‘Learners take sequential lessons’ setting is enabled",
      skip_task_review: "Skip Task Review",
      skip_task_review_desc: "Allow learners to skip the task review and move on to the next lesson."
    },
    chapter: {
      rename_chapter: 'Rename Chapter',
      create_chapter: 'Create Chapter',
      chapter_name: 'Chapter Name',
      untitled: 'Untitled Chapter',
      chapter_placeholder: 'Enter chapter name',
      add: 'Add Chapter',
      empty:
        'Start by adding a chapter — which helps you to group video lessons on a topic together.',
      reorder: 'Reorder Your Chapters',
      reorder_desc:
        'Reorder your chapters the way you want them to appear for your learners.',
      delete: {
        title: 'Are you sure you want to delete this Chapter?',
        description: 'On deleting, this Chapter will be deleted forever.',
        delete_btn: 'Yes, Delete it!',
        cancel: "No, keep it",
      },
      title_updated: 'Chapter renamed',
      deleted: 'Chapter deleted',
      added: 'Chapter added',
    },
    lesson: {
      untitled: 'Untitled Lesson',
      add: 'Add Lesson',
      edit: 'Edit Video Lesson',
      from_library: '',
      description_label: 'Lesson Description',
      description_caption: 'This description is editable. Turn the toggle on to sync with video description.',
      supporting_document: 'Supporting Documents',
      supporting_document_desc:
        'Add helpful resources for learners to use as reference alongside this lesson.',
      maximum_upload_size: 'Maximum Upload Size: %{size}MB',
      embed_url: 'Embed URL',
      embed_caption: 'Enter the URL you want to display in your lesson.',
      article: {
        edit: 'Edit Article Lesson',
        description_label: 'Article Content',
        description_caption:
          'Create and format your article using the editor tools below.',
        import_description_label: 'Trainn Library Article',
        import_description_caption:
          'Article is present in Trainn Library. Click here to edit.',
      },
      video: {
        use_description_caption:
          '<span class="t-td--under t-cursor--pointer">Synced with the video description</span>. Turn the toggle off to edit here.',
        use_external_description_label: 'Link Lesson Description with Video',
        use_external_description_desc:
            'Use the video description as the lesson description.',
        },
      delete: {
        title: 'Are you sure you want to delete this lesson?',
        description:
          'This action cannot be undone. All content and linked resources will be permanently removed, and learners will lose access to this material.',
        delete_btn: 'Yes, delete permanently',
        cancel: 'No, keep lesson',
      },
      deleted: 'Lesson deleted',
      questions: 'Questions',
      quiz_settings: 'Quiz settings',
      shuffle_question_order_label: 'Shuffle question display order',
      shuffle_question_order_desc:
        'Present questions in a different order for each learner to discourage answer sharing.',
      shuffle_choice_order_label: 'Shuffle Answers',
      shuffle_choice_order_desc:
        'Randomize answer choices for each learner to reduce memorization and sharing.',
      guide_assessment_mode_label: 'Enable Assessment Mode',
      guide_assessment_mode_desc:
        'Present guide as a test environment without help texts or spotlights and allow learners to demonstrate their knowledge.',
      success: {
        lessons_reordered: 'Lessons reordered',
        lesson_updated: 'Lesson updated',
        resource_uploaded: 'Resource uploaded successfully',
        resource_deleted: 'Resource deleted successfully',
        file_uploaded: 'File uploaded',
        video_updated: 'Lesson video updated',
        chapters_reordered: 'Chapters reordered',
      },
    },
    empty: 'Your Course Library is empty. Start by creating a course.',
    no_matches: "No matches found for '%{search_term}'",
    no_matching_results: 'No matching results found',
    delete: {
      title: 'Are you sure you want to delete this course?',
      description:
        'All content and links associated with this course will be permanently deleted, and learners will lose access.',
      delete_btn: 'Yes, Delete it!',
      cancel: "No, Keep it",
    },
    assessment: {
      upload_question: 'Upload Questions',
      add_update_questions: 'Questions',
      question_description:
        'Add multiple choice / checkbox type questions to your assessment',
      quiz_builder: 'Quiz Builder',
      go_to_quiz_add: 'Add Questions',
      go_to_quiz_edit: 'Edit Questions',
      import_questions: 'Import Questions',
      upload_question_desc: 'Watch video to learn more',
      without_completeing_course_label:
        'Take assessment without course completion ',
      without_completeing_course_desc:
        'Your learners can take the assessment without completing the course.',
      minimum_duration_label: 'Estimated time to finish the assessment',
      minimum_duration_desc:
        'This is to inform your learners about the average time it takes to complete the assessment.',
      maximum_duration_label: 'Assessment duration',
      maximum_duration_desc:
        'Keep the portal open for a certain duration before auto-submitting.',
      can_retake_label: 'Can retake the assessment',
      can_retake_desc: 'Learner can retake the assessment even after certification',
      can_shuffle_question_label: 'Shuffle Questions',
      can_shuffle_question_desc:
        'Present questions in a different order for each learner to discourage answer sharing.',
      number_of_questions_label: 'Number of questions',
      number_of_questions_desc: 'Set the number of questions in the assessment',
      number_of_quiz_questions_desc: 'Set the number of questions in quiz',
      pass_percentage_label: 'Passing Score',
      pass_percentage_desc: 'Define the minimum percentage required to successfully complete this quiz.',
      exam_pass_percentage_desc: 'Minimum score required to complete the exam',
      attempts_label: 'Number of attempts allowed',
      attempts_desc:
        'Set the number of times your learners can take the assessment',
      attempts_gap_label: 'Reattempt window',
      attempts_gap_desc:
        'Set the duration your learners have to wait between reattempts of the assessment, on failure.',
      attempt_summary_label: 'Show Attempt Results',
      attempt_summary_desc:
        'Display whether answers were correct or incorrect immediately after quiz completion.',
      correct_answers_label: 'Show Correct Answers',
      correct_answers_desc: 'Reveal the correct answers in the summary after the learner completes the quiz.',
      no_attempts: 'One attempt ',
      three_attempts: '3 attempts',
      unlimited_attempts: 'Unlimited attempts',
      title: 'Enter Quiz Name',
      custom: 'Custom',
      hours: 'Hours',
      hour: 'Hour',
      mins: 'Mins',
      error: {
        question_title: 'Please fill the question title',
        question_points: 'Please fill the question points',
        option_text: 'Please fill the option text',
        option_correct: 'Please select the correct option',
        duplicate_choices: 'Please enter unique choices',
      },
      exam_settings: 'Exam Settings',
      no_time_limit: 'No limit',
      thirty_minutes: '30 minutes',
      sixty_minutes: '60 minutes',
    },
    quiz: {
      maximum_duration_label: 'Quiz Duration',
      maximum_duration_desc:
        'Set how long learners have to complete the quiz before automatic submission.',
      attempts_label: 'Attempt Limit',
      attempts_desc:
        'Set the number of times a learner can take this quiz.',
    },
    guide: {
      title: 'Untitled Guide',
      settings_updated: 'Guide settings updated'
    },
    task: {
      offline: 'Offline',
      file_upload: 'File upload',
      free_text: 'Free text',
      task_settings_updated: 'Task Settings Updated',
      tabs: {
        description: 'Description',
        settings: 'Settings'
      },
      task_type_title: 'Task Type',
      task_type_desc: 'Choose the type of task to assign to your learner',
      cta_title: 'Button Label',
      cta_desc: 'Edit the text for the submission button',
    },
    certificate: {
      validity_label: 'Certification Validity',
      validity_desc:
        'Define how long certificates remain valid after they are issued.',
      content_label: 'Certificate Text',
      content_desc: 'This template appears on all certificates for this course.',
      auth_label: 'Signing Authority',
      auth_desc:
        'Add the name and title of the person authorizing this certificate.',
      logo_label: 'Logo on the certificate',
      logo_desc: 'Upload a transparent .png of the company logo',
      content_text1: 'This is to certify that',
      content_text2: 'has successfully completed the course',
      learner_name: 'learner name',
      course_name: 'course name',
      logo_file_desc: '<b>Signature:</b> Upto 2800x1800 | .png',
      authority_name: 'Name of the authority',
      signature_preview: 'Signature Preview',
      course_certificate_name: 'Certificate Name',
      course_certificate_name_desc:
        "Enter a name for your certificate (use a different name from your course's name).",
      settings: 'Certification Settings',
      settings_updated: 'Certification settings has been updated',
      certification_method: 'Certification Method',
      certification_method_desc:
        'Choose how learners earn certificates for this course.',
      completion_percentage: 'Course Completion Percentage',
      completion_percentage_desc:
        'Set the percentage of content learnets must finish to receive certification.',
      accredible: {
        label: 'Accredible',
        desc: 'Select certificate for the course.',
        placeholder: 'Select certificate',
        group_fallback_name: 'Group #{id}',
        group_missing_label: 'Unavailable Accredible group (ID {id})',
        group_not_found_message:
          'The saved Accredible group could not be found. It may have been deleted in Accredible.'
      },
      type: 'Certification Issuer',
      type_desc: 'Choose certification issuer for this course.'
    },
    table: {
      name: 'Name',
      status: 'Status',
      created_on: 'Created on',
      authors: 'Authors',
      enrollments: 'Enrollments',
      completions: 'Completions',
      certifications: 'Certifications',
      drop_off: 'Drop-off',
      retention: 'Retention',
      reviews: 'Reviews',
      avg_rating: 'Avg. Rating',
      last_updated: 'Last Updated',
      action: 'Action',
      draft: 'Draft',
      published: 'Published',
      risky: 'At Risk',
      healthy: 'Healthy',
      attention: 'Attention',
      risky_tooltip:
        'Drop-off is above 50% or avg rating is below 3.5. Significant learner fall-off — consider revising the course.',
      attention_tooltip:
        'Drop-off is between 30% and 50% or avg rating is below 4. Engagement is slipping — review pacing and content.',
      healthy_tooltip:
        'Drop-off is 30% or less and avg rating is 4 or higher (or not yet rated). Learners are completing this course as expected.'
    },
    edit_course: 'Edit',
    preview_course: 'Preview',
    clone_course: 'Clone',
    delete_course: 'Delete',
    last_updated: 'Last updated:',
    settings_updated: 'Course settings updated',
    authors_updated: 'Authors updated',
    cover_updated: 'Course cover updated',
    nav: {
      course_overview: 'Course Overview',
      course_content: 'Course Content',
      exam_certification: 'Assessment & Certification',
      exam: 'Exam',
      exam_settings: 'Assessment Settings',
      exam_questionnaire: 'Assessment Questionnaire',
      quiz_settings: 'Settings',
      quiz_questionnaire: 'Questionnaire',
      certification: 'Certification',
      certification_settings: 'Settings',
      no_lessons_found: 'Click + icon to add lesson',
      add_chapter: 'Add Chapter',
      add_lesson: 'Add Lesson',
      popover: {
        edit_name: 'Rename Chapter',
        reorder: 'Reorder Chapter',
        delete: 'Delete Chapter',
        choose_lesson_type: 'Choose Lesson Type',
        video_lesson: 'Add Video',
        add_article: 'Add Article',
        article_lesson: 'Add Article',
        add_pdf: 'Add PDF',
        add_knowledge_check: 'Create Quiz',
        add_task_lesson: 'Create Task',
        add_guide: 'Add Guide',
        add_embed_url: 'Add Embed',
        add_scorm: 'Add SCORM',
      },
    },
    pdf_lesson: {
      create_lesson_heading: 'Create PDF Lesson',
      upload_tab: 'Upload PDF',
      library_search_label: 'Import PDF from Library',
      library_search_placeholder: 'Search for PDFs',
      choose_pdf_file: 'Choose a PDF to upload',
      pdf_title_field: 'PDF title',
      pdf_title_placeholder: 'Enter a descriptive title',
    },
    unsaved_changes_modal: {
      title: 'You Have Unsaved Changes',
      description: 'Would you like to save your changes before leaving this page?',
      discard: 'Discard changes',
      save: 'Save and continue',
    },
    title_updated: 'Course renamed',
    deleted: 'Course deleted',
  },
  events: {
    untitled: 'Untitled Event',
    last_updated: 'Last updated:',
    preview: 'Preview Event',
    copy_link: 'Copy Registration Link',
    event_name: 'Event Name',
    title_updated: 'Event renamed',
    nav: {
      event_overview: 'Event Overview',
      sessions: 'Upcoming Sessions',
      past_session: 'Past Sessions',
      add_session: 'Add Session'
    },
    tab: {
      session_settings: 'Settings',
      session_attendees: 'Attendees',
    },
    session: {
      untitled: 'New session',
      add: 'Add Session',
      session_name: 'Session name',
      create_session: 'Create session',
      cancelled: 'Session cancelled',
      deleted: 'Session deleted',
      added: 'Session added',
      session_settings_updated: 'Session settings updated',
      no_attendees: 'No Attendees found',
      session_progress: 'Session in progress',
      session_ended: 'Session has ended',
      session_cancelled: 'Session cancelled',
      invited: 'Learners has been invited',
      delete: {
        title: 'Are you sure you want to delete this session?',
        delete_btn: 'Yes, Delete it',
        cancel: "No, keep it",
      },
      table: {
        name: 'Name',
        email: 'Email',
        status: 'Status',
        joined: 'Joined',
        registered: 'Registered',
        invited: 'Invited',
      },
      settings: {
        unlimited: 'Unlimited',
        date: 'Session Date',
        date_desc: 'Schedule when this training session will take place.',
        start_time: 'Start time',
        start_time_desc: 'Choose a start time for the session',
        session_duration: 'Session Duration',
        session_duration_desc: 'Specify how long the session will run in minutes.',
        session_url: 'Session URL',
        session_url_desc: 'Add the link where participants will join the virtual meeting.',
        session_instructor: 'Instructor',
        session_instructor_desc: 'Choose who will conduct this training session from the list.',
        session_seats: 'Available seats',
        session_seats_desc: 'Set the maximum number of learners who can register for the session or select unlimited.',
      }
    },
    desc_placeholder:
      'Write a short summary that will appear in event listings and email communications to learners.',
    long_desc_placeholder:
      'Write a detailed description about the session content, goals, and what learners will gain.',
    general: {
      details: 'Short Description',
      description: 'Edit this event’s summary:',
      access_type: 'Access type',
      access_type_desc: 'On selecting access type will be set to academy',
      time_zone: 'Time Zone',
      time_zone_desc: "Select the time zone for accurate scheduling that matches your learners' locations.",
      empty_fields_message: 'Fields must not be left empty',
      default_time_message: 'Choose a valid time',
      delete: 'Delete Event',
      invalid_url: 'Enter a valid session URL',
      events_deleted: 'Event deleted',
      delete_title: 'Are you sure you want to delete this event?',
      delete_description: 'Deleting this event will cancel all upcoming sessions and notify registered learners. This action cannot be undone.',
      empty_summary: 'Please enter a short description for this event',
      display_in_academy: 'Display this event in Academy',
      display_in_academy_desc: "Make This Event Visible in Your Academy's Event Calendar."
    },
    table: {
      event_name: 'Event name',
      next_session: 'Next session',
      learner_details: 'Attendee Details',
      learner_name: 'Name',
      registered: 'Registered',
      invited: 'Invited',
      cancelled: 'Cancelled',
    },
    empty: 'No Training events have been created. Start by creating one.'
  },
  builder: {
    publish: 'Publish Academy',
    published_successfully: 'Academy published successfully',
    upload: {
      title: 'Page Cover',
    },
    delete: {
      title: 'Are you sure you want to delete %{page} page?',
      description: 'On deleting, %{page} page will be deleted forever.',
      delete_btn: 'Yes, Delete it!',
      cancel: "No, keep it",
    },
    language: {
      delete: {
        title: 'Are you sure you want to delete %{language} Academy Page?',
        description:
          'On deleting, %{language} Academy Page will be deleted forever.',
        button: 'Yes, Delete it!',
        cancel: "No, keep it",
      },
    },
    pages: {
      login: 'Login Page',
      home: 'Home Page',
      addPage: 'Add Page'
    },
    login: {
      title: 'Login Settings',
      desc: 'Customize your academy home page.',
      public: {
        caption: 'Your Academy is Public',
        title: 'Everybody can access your academy',
      },
      private: {
        caption: 'Your Academy is Private',
        title: 'User Authentication Methods',
        custom_sso:
          'You have configured a custom SSO implementation. Contact our support team to modify',
      },
      auth_type: {
        sso: 'SSO Authentication',
        sso_documentation_link:
          "Read our <a target='_blank' href='https://help.trainn.co/share/dabTAiuVyypmrtWwGmDL9w'>SSO integration guide</a> for detailed setup instructions.",
        train_login: 'Email Authentication',
        train_auth_customer_signup: 'Allow anyone to signup',
        login_url: 'Paste redirection URL',
        login_url_label: 'SSO Authentication',
        saml: 'Single Sign-On SAML',
        saml_documentation_link:
          "Read our <a target='_blank' href='https://help.trainn.co/share/BxVWDODPORX6v0vUn2F3JQ'>SSO SAML integration guide</a> for detailed setup instructions.",
        saml_login_url: 'Login URL',
        saml_login_url_desc: 'Users will be redirected to this URL to login.',
        saml_certificate: 'SAML Certificate',
        saml_certificate_desc:
          'SAML X.509 certificate to authenticate with your Identity Provider',
        logout_url: 'Remote Logout URL (optional)',
        logout_url_desc:
          'Users will be redirected to this URL when they logout from Hub',
        sso_lock: 'Your current plan does not support SSO authentication. Upgrade your plan for advanced security features.',
        saml_lock: 'Your current plan does not support SAML authentication. Upgrade your plan for advanced security features.'
      },
      page_title: 'Page title',
      page_subtitle: 'Page subtitle'
    },
    design: {
      login_title: 'Login Page Design',
      home_title: 'Home Page Settings',
      default_title: 'Page Settings',
      home_desc: 'Customize your academy home page.',
      header: 'Enter page heading',
      sub_header:
        'Edit page sub-heading: Give a hearty welcome to your users or a brief overview of what they can expect from your academy',
      layout_title: 'Choose the position of your login form on the page.',
      layout: {
        left: 'Left',
        center: 'Center',
        right: 'Right',
      },
      home_layout: {
        left: 'Banner Image aligned to the left of the page',
        center: 'Banner Image centered on the page',
        right: 'Banner Image aligned to the right of the page',
      },
      align: {
        left: 'Linear with left aligned headers',
        center: 'Linear with left aligned headers',
        right: 'Linear with left aligned headers',
      },
      brand: 'Brand Styles',
    },
    settings: {
      title: 'Advanced Settings',
      desc: 'Configure additional features for your academy.',
      header: {
        caption: 'Header',
        title: 'You can add up to three links in your academy header',
      },
      footer: {
        caption: 'Foot notes',
        title: 'Enable a footer for the page',
      },
      add_login_foot_note:
        'Add a footnote to the login page — add links if you need',
      add_foot_note:
        'Add a footnote to direct your users to your desired page in case they need further support',
      link_text: 'Link Text',
      label: 'Label',
      url: 'URL',
      edit_home_page:
        'Customize the home page of your academy by linking desired courses',
      edit_home_cta: 'Edit Home Page',
      override_home_page: 'Show different courses for custom user segments',
      override_home_cta: 'Create New Home Override',
      override_title:
        'Override: Create a new home override for custom user segments',
      override_title_placeholder: 'Name it for your reference',
      override_title_desc:
        'In the following step, you can set up who has access to this page',
      override_title_cta: 'Create Page',
      add_link: 'Add link',
      edit_link: 'Edit link',
      remove_link: 'Remove link',
      allow_course_jump: 'Create a structured Learning path for Learners',
      allow_course_jump_desc:
        'Enable this to set up a learning path. Learners must finish all courses in a category before moving to the next.',
    },
    content: {
      link_courses: 'Link Courses',
    },
    categories: {
      untitled: 'Untitled Category',
      add: 'Add Category',
      empty:
        'Start by creating a category — which helps you to group courses together.',
      reorder: 'Reorder your categories',
      structured_learning: 'Lock category to ensure learners finish each course before the next unlocks.',
      delete: {
        title: 'Are you sure you want to delete this Category?',
        description: 'On deleting, this Category will be deleted forever.',
        delete_btn: 'Yes, Delete it!',
        cancel: "No, keep it",
      },
    },
  },
  conditions: {
    title: 'Who can see this page?',
  },
  config: {
    title: 'Academy Configurations',
    desc: 'Set up the basic configuration options for your Academy.',
    cta: 'Save Configurations',
    brand_essentials: 'Brand Styles',
    brand_identity: 'Brand Identity',
    brand_color: 'Brand Color',
    brand_color_desc:
      'Choose a primary color for for visual elements in your academy.',
    logo_title: '<b>Logo: </b>upto 240x120',
    favicon_title: '<b>Favicon: </b>30x30',
    hex: '#0359af',
    analytics: 'Analytics',
    updated: 'Settings updated successfully',
    image_updated: 'Image updated successfully',
    copy_url: 'Copy Academy URL',
    go_to: 'Go to Academy',
    moderators: 'Moderators',
    moderators_desc: 'Add team members who can manage your Academy and moderate discussions.',
    languages: {
      title: 'Languages',
      desc: 'Add languages to make your academy accessible to global learners.',
      add: 'Add Language',
      default: 'Default Language',
      popover_title: 'Add Academy Languages',
    },
  },
  email: {
    title: 'Email Notification',
    desc: 'Manage email settings and notification templates.',

    welcome_email: {
      title: 'Welcome Mail',
      desc: 'A welcome email will be sent when a learner signs up or logs in to your Academy.',
    },
    invite_email: {
      title: 'Invite Mail',
      desc: 'An invite email will be sent when the admin invites a learner.',
    },
    course_completion_email: {
      title: 'Course Completion Reminder Mail',
      desc: "Send automated reminder emails to help learners complete courses they haven't finished based on their previous engagement time.",
    },
    course_assigning_email: {
      title: 'Course Assignment Mail',
      desc: 'A mail would be sent everytime when a admin assigns a new course to the learners.',
    },

    edit_template: 'Edit Template',
    reminder_in_weeks:
      "How many weeks after learner inactivity should reminders be sent?",
  },
  reorder: 'Reorder Your Chapters',
  learner_groups: {
    static: {
      label: 'Choose users ',
      desc: 'You can choose one or multiple customers',
      search: 'Search customers…',
    },
    dynamic: {
      label: 'Filter dynamically through authentication',
      add_condition: '+ Add Condition',
    },
  },
  course_feedbacks: {
    title: 'Course Feedbacks',
    desc: 'Feedback for your course',
    empty: 'No feedbacks yet',
    rating: 'Rating',
    comment: 'Comment',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    date: 'Date',
  },
  course_analytics: {
    analytics: 'Analytics',
    learners_enrolled: 'Learners Enrolled',
    learners_completed: 'Learners Completed',
    assessment_taken: 'Assessment Taken',
    certified_learners: 'Certified Learners',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    enrolled_on: 'Enrolled On',
    completed: 'Completed',
    certified: 'Certified',
    assessment_attempts: 'Assessment Attempts',
    last_assessment_score: 'Last Assessment Score',
    yes: 'Yes',
    no: 'No',
    no_results_found: 'No results found!',
    export: {
      button: 'Export',
      title: 'Export Course Analytics',
      desc: `A CSV file containing the course analytics will be sent to your email.`,
    },
    course_reviews: 'Course Reviews',
  },
  analytics_dashboard: {
    title: 'Analytics',
    description:
      'Get a summary of metrics to measure the performance of your Academy.',
    empty_dashboard: 'No analytics found!',
    live_courses: 'Live Courses',
    enrolled_courses: 'Total Course Enrollments',
    completed_courses: 'Total Course Completions',
    total_certifications: 'Total Certificates Issued',
    total_learners: 'Total Number of Learners',
    total_enrolled_companies: 'Total Enrolled Companies',
    total_course_enrolment: 'Total Course Enrollments',
    total_course_completions: 'Total Course Completions',
    total_certificates_issued: 'Total Certificates Issued',
    number_of_signups: 'Number of Signups',
    signups: 'Signups',
    top_companies: 'Top Companies',
    course_enrollment: 'Course Enrollment',
    courses: 'Courses',
    enrollments: 'Enrollments',
    top_courses: 'Top Courses',
    top_learners: 'Top Learners',
    active_learners: 'Unique Active Learners',
    learners: 'Learners',
    top_learnres: 'Top Learners',
    total_engagement_time: 'Total Engagement Time',
    engagement: 'Engagement',
    average_engagement_time: 'Average Engagement Time',
    retention_cohort: {
      title: 'Retention Cohort Analysis',
      week: 'Week',
      signed_up: 'Signed up users',
      desc: 'No. of users active in the consecutive weeks',
    },
    duration: 'Duration',
    filters: {
      all_companies: 'All Companies',
      no_of_enrollments: 'By No of Enrollments',
      unique_active_learners: 'By Unique Active Learners',
      course_completions: 'By Course Completions',
      certifications_issued: 'By Certifications Issued',
      engagement_time: 'By Engagement Time',
      number_of_certificates: 'By Number of Certificates',
      courses_completed: 'By Courses Completed',
      course_enrollments: 'Course Enrollments',
      course_completions_plain: 'Course Completions',
      certifications_issued_plain: 'Certifications Issued',
      enrollments: 'enrollments',
      learners: 'learners',
      completions: 'completions',
      certifications: 'certifications',
      courses: 'courses',
      certificates: 'certificates',
    },
    start_sharing_courses: 'No enrollments yet — start inviting your learners!',
  },
  course_quiz_attempts: {
    quiz_attempts: 'Quiz Attempts',
    name: 'Quiz Name',
    learner_name: 'Attempted By',
    attempt_date: 'Attempted At',
    attempt_count: 'No Of Attempt',
    score: 'Score',
    status: 'Status',
    latest_attempt: 'Show latest attempts'
  }
};